import { useNavigate } from "react-router";
import { useIntl } from "react-intl";

// Circular nav-up affordance shared across sub-pages. Returns the user to the
// previous history entry (`navigate(-1)`), not a hard-coded parent route -
// that's the project-wide convention so a back action always reflects where
// the user actually came from. Visuals live in .smycles-back-button
// (index.css); see docs/UI_CONVENTIONS.md → Actions And Signals.

export function BackButton() {
  const navigate = useNavigate();
  const intl = useIntl();
  const label = intl.formatMessage({ id: "common.back", defaultMessage: "Back" });
  return (
    <button
      id="back-button"
      type="button"
      onClick={() => navigate(-1)}
      title={label}
      aria-label={label}
      className="smycles-back-button"
    >
      ←
    </button>
  );
}
